import {
  animationFrames,
  distinctUntilChanged,
  map,
  NEVER,
  switchMap,
  take,
  type Observable,
} from 'rxjs';
import { activeViewsStatus$ } from './activeViewsStatus$';
import { isViewLoading, isViewSettled } from './activeViewsStatusOperations';

export const getIsViewLoading$ = (
  viewInstanceId: string
): Observable<boolean> =>
  activeViewsStatus$.pipe(
    map(status => isViewLoading(status, viewInstanceId)),
    distinctUntilChanged()
  );

const untilNextFrame = (isSettled: boolean): Observable<unknown> =>
  isSettled ? animationFrames().pipe(take(1)) : NEVER;

/** Emits once the view has been registered and hold-free for a whole frame. */
export const whenViewSettled$ = (viewInstanceId: string): Observable<void> =>
  activeViewsStatus$.pipe(
    map(status => isViewSettled(status, viewInstanceId)),
    distinctUntilChanged(),
    switchMap(untilNextFrame),
    take(1),
    map(() => undefined)
  );
